// SPLIT SLIDESHOW JAVASCRIPT
(function() {
  'use strict';
  
  class SplitSlideshow {
    constructor(sectionElement) {
      this.section = sectionElement;
      this.container = sectionElement.querySelector('.split-slideshow-container');
      this.slides = Array.from(sectionElement.querySelectorAll('.split-slide'));
      this.indicators = Array.from(sectionElement.querySelectorAll('.pagination-dot'));
      this.prevButton = null; // Removed chevron navigation
      this.nextButton = null; // Removed chevron navigation
      
      this.currentSlide = 0;
      this.totalSlides = this.slides.length;
      this.autoplayEnabled = sectionElement.dataset.autoplay === 'true';
      this.autoplaySpeed = parseInt(sectionElement.dataset.autoplaySpeed) || 6000;
      this.overlayOpacity = parseFloat(sectionElement.dataset.overlayOpacity) || 0.45;
      
      this.autoplayInterval = null;
      this.isPaused = false;
      this.isTransitioning = false;
      this.touchStartX = 0;
      this.touchEndX = 0;
      this.isDragging = false;
      this.dragStartX = 0;
      this.currentX = 0;
      this.dragThreshold = 50;
      
      this.init();
    }
    
    init() {
      if (this.totalSlides <= 1) return;
      
      this.setupEventListeners();
      this.setupLazyLoading();
      this.startAutoplay();
      
      // Initialize first slide
      this.updateSlideStates();
      this.updateIndicators();
    }
    
    setupEventListeners() {
      // Pagination dots
      this.indicators.forEach((indicator, index) => {
        indicator.addEventListener('click', () => this.goToSlide(index));
      });
      
      // Keyboard navigation
      document.addEventListener('keydown', (e) => {
        if (!this.section.contains(document.activeElement)) return;
        
        switch(e.key) {
          case 'ArrowLeft':
            e.preventDefault();
            this.previousSlide();
            break;
          case 'ArrowRight':
            e.preventDefault();
            this.nextSlide();
            break;
        }
      });
      
      // Hover pause
      this.section.addEventListener('mouseenter', () => this.pauseAutoplay());
      this.section.addEventListener('mouseleave', () => this.resumeAutoplay());
      
      // Touch events for mobile
      this.section.addEventListener('touchstart', (e) => this.handleTouchStart(e), { passive: true });
      this.section.addEventListener('touchend', (e) => this.handleTouchEnd(e), { passive: true });
      
      // Mouse drag events for desktop
      this.section.addEventListener('mousedown', (e) => this.handleMouseDown(e));
      this.section.addEventListener('mousemove', (e) => this.handleMouseMove(e));
      this.section.addEventListener('mouseup', (e) => this.handleMouseUp(e));
      this.section.addEventListener('mouseleave', (e) => this.handleMouseUp(e));
      
      // Visibility change pause
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
          this.pauseAutoplay();
        } else {
          this.resumeAutoplay();
        }
      });
    }
    
    handleTouchStart(e) {
      this.touchStartX = e.touches[0].clientX;
    }
    
    handleTouchEnd(e) {
      this.touchEndX = e.changedTouches[0].clientX;
      this.handleSwipe();
    }
    
    handleSwipe() {
      const swipeThreshold = 50;
      const diff = this.touchStartX - this.touchEndX;
      
      if (Math.abs(diff) > swipeThreshold) {
        if (diff > 0) {
          // Swipe left - next slide
          this.nextSlide();
        } else {
          // Swipe right - previous slide
          this.previousSlide();
        }
      }
    }
    
    setupLazyLoading() {
      if ('IntersectionObserver' in window) {
        const imageObserver = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              const img = entry.target;
              if (img.dataset.src) {
                img.src = img.dataset.src;
                img.removeAttribute('data-src');
                img.classList.remove('lazyload');
                imageObserver.unobserve(img);
              }
            }
          });
        });
        
        this.section.querySelectorAll('img[data-src]').forEach(img => {
          imageObserver.observe(img);
        });
      } else {
        // Fallback for older browsers
        this.section.querySelectorAll('img[data-src]').forEach(img => {
          img.src = img.dataset.src;
          img.removeAttribute('data-src');
          img.classList.remove('lazyload');
        });
      }
    }
    
    nextSlide() {
      if (this.isTransitioning) return;
      
      const nextIndex = (this.currentSlide + 1) % this.totalSlides;
      this.goToSlide(nextIndex);
    }
    
    previousSlide() {
      if (this.isTransitioning) return;
      
      const prevIndex = (this.currentSlide - 1 + this.totalSlides) % this.totalSlides;
      this.goToSlide(prevIndex);
    }
    
    goToSlide(index) {
      if (this.isTransitioning || index === this.currentSlide) return;
      
      this.isTransitioning = true;
      
      // Remove active class from current slide
      this.slides[this.currentSlide].classList.remove('active');
      
      // Update current slide
      this.currentSlide = index;
      
      // Add active class to new slide
      this.slides[this.currentSlide].classList.add('active');
      
      // Update indicators
      this.updateIndicators();
      
      // Reset transition flag after animation completes
      setTimeout(() => {
        this.isTransitioning = false;
      }, 1200); // Match CSS transition duration
    }
    
    updateSlideStates() {
      this.slides.forEach((slide, index) => {
        slide.classList.toggle('active', index === this.currentSlide);
      });
    }
    
    updateIndicators() {
      this.indicators.forEach((indicator, index) => {
        indicator.classList.toggle('active', index === this.currentSlide);
      });
    }
    
    startAutoplay() {
      if (!this.autoplayEnabled || this.totalSlides <= 1) return;
      
      this.autoplayInterval = setInterval(() => {
        if (!this.isPaused && !this.isTransitioning) {
          this.nextSlide();
        }
      }, this.autoplaySpeed);
    }
    
    pauseAutoplay() {
      this.isPaused = true;
      if (this.autoplayInterval) {
        clearInterval(this.autoplayInterval);
        this.autoplayInterval = null;
      }
    }
    
    resumeAutoplay() {
      this.isPaused = false;
      this.startAutoplay();
    }
    
    // Mouse drag handlers
    handleMouseDown(e) {
      if (e.target.closest('.pagination-dot') || e.target.closest('.luxury-cta-button')) return;
      
      this.isDragging = true;
      this.dragStartX = e.clientX;
      this.currentX = 0;
      this.pauseAutoplay();
      
      // Prevent text selection during drag
      e.preventDefault();
      this.container.style.cursor = 'grabbing';
    }
    
    handleMouseMove(e) {
      if (!this.isDragging) return;
      
      const diff = this.dragStartX - e.clientX;
      this.currentX = diff;
      
      // Visual feedback during drag
      this.container.style.transform = `translateX(${-diff}px)`;
    }
    
    handleMouseUp(e) {
      if (!this.isDragging) return;
      
      this.isDragging = false;
      this.container.style.cursor = 'grab';
      this.container.style.transform = '';
      
      // Handle swipe based on drag distance
      if (Math.abs(this.currentX) > this.dragThreshold) {
        if (this.currentX > 0) {
          this.nextSlide();
        } else {
          this.previousSlide();
        }
      }
      
      this.resumeAutoplay();
    }
    
    destroy() {
      this.pauseAutoplay();
      
      // Remove event listeners
      if (this.prevButton) {
        this.prevButton.removeEventListener('click', this.previousSlide);
      }
      
      if (this.nextButton) {
        this.nextButton.removeEventListener('click', this.nextSlide);
      }
      
      this.indicators.forEach(indicator => {
        indicator.removeEventListener('click', this.goToSlide);
      });
      
      // Clean up touch events
      this.section.removeEventListener('touchstart', this.handleTouchStart);
      this.section.removeEventListener('touchend', this.handleTouchEnd);
      
      // Clean up mouse drag events
      this.section.removeEventListener('mousedown', this.handleMouseDown);
      this.section.removeEventListener('mousemove', this.handleMouseMove);
      this.section.removeEventListener('mouseup', this.handleMouseUp);
      this.section.removeEventListener('mouseleave', this.handleMouseUp);
      
      // Clean up keyboard events
      document.removeEventListener('keydown', this.handleKeyDown);
    }
  }
  
  // Initialize all split slideshow sections
  function initializeSplitSlideshows() {
    const sections = document.querySelectorAll('.split-slideshow-section');
    
    sections.forEach(section => {
      // Prevent multiple initializations
      if (section.dataset.initialized) return;
      
      new SplitSlideshow(section);
      section.dataset.initialized = 'true';
    });
  }
  
  // Handle dynamic content loading
  function handleDynamicContent() {
    // Observe for new sections added to the DOM
    const observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        mutation.addedNodes.forEach(node => {
          if (node.nodeType === 1 && node.classList && node.classList.contains('split-slideshow-section')) {
            initializeSplitSlideshows();
          }
        });
      });
    });
    
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
  
  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initializeSplitSlideshows();
      handleDynamicContent();
    });
  } else {
    initializeSplitSlideshows();
    handleDynamicContent();
  }
  
  // Export for global access
  window.SplitSlideshow = SplitSlideshow;
  
  // Shopify section events
  if (typeof window.Shopify !== 'undefined' && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
      if (event.detail.sectionId) {
        const section = document.querySelector(`[data-section-id="${event.detail.sectionId}"]`);
        if (section && section.classList.contains('split-slideshow-section')) {
          initializeSplitSlideshows();
        }
      }
    });
    
    document.addEventListener('shopify:section:unload', (event) => {
      if (event.detail.sectionId) {
        const section = document.querySelector(`[data-section-id="${event.detail.sectionId}"]`);
        if (section && section.SplitSlideshowInstance) {
          section.SplitSlideshowInstance.destroy();
        }
      }
    });
  }
  
})();